/**
 * Shared field primitives for the relay schedule editors.
 *
 * Keeps the schedule timing controls consistent between the legacy
 * RelaySchedulesForm (EditSchedulesDialog) and the dashboard ScheduleRow
 * (RelayBlade) without each copy re-declaring them.
 *
 * Contains:
 * - SmallTimePicker — compact TimePicker matching small-size text fields
 * - deriveDirection — sun-offset sign → Before / At / After direction
 */
import { styled } from '@mui/material';
import { TimePicker } from '@mui/x-date-pickers';
import React from 'react';

export const SmallTimePicker = styled(props => <TimePicker {...props} />)(() => ({
  '& .MuiPickersFilledInput-sectionsContainer': {
    paddingTop: 16,
    paddingBottom: 4,
  },
}));

// Schedule offset uses a 3-way Before / At / After model so "0 minutes
// before" and "0 minutes after" — which collapse to the same moment —
// share a single unambiguous "At" affordance.
//
// Form value contract:
//   before → -magnitude
//   at     →  0
//   after  → +magnitude
export function deriveDirection(value) {
  if (value < 0) return 'before';
  if (value > 0) return 'after';
  return 'at';
}
